import "../../../App.css";
import React, {useEffect, useState} from "react";
import {Button, Descriptions, Form, Layout, message, Modal, Typography} from "antd";
import "antd/dist/reset.css";
import {useOrderId} from "../../../hooks/UseOrderId";
import {PaymentType} from "../../../App";
import {ProviderTypeEnum} from "../../../types/ProviderTypeEnum";
import WrappedCard from "../../antd/WrappedCard";
import "./PkRouteSettingMode.css";
import {Copyable} from "../../common/Copyable";
import {usePostCheckoutApi} from "../../../api";
import {CardTypeEnum} from "../../../types/CardTypeEnum";
import teachingVideo from "../../../assets/billpayTeching.mp4";

const {Content} = Layout;

function PkBillpayMode({getCheckoutInfoData}: PaymentType) {
    const orderId = useOrderId();

    const [isSubmitted, setIsSubmitted] = useState(getCheckoutInfoData?.checkoutStatus === "SUBMITTED");

    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const [showBankCardHintModal, setShowBankCardHintModal] = useState(false);


    const {loading, executePost} = usePostCheckoutApi(orderId);

    const submitCheckout = () => {
        executePost({
            data: {
                providerName: CardTypeEnum.EasyPaisa,
                providerType: ProviderTypeEnum.BILL,
                customerName: getCheckoutInfoData?.receiverName,
                customerAccount: getCheckoutInfoData?.receiverAccount,
                customerIdCard: getCheckoutInfoData?.receiverIdCard,
            }
        }).catch((error) => {
                setIsSubmitted(true);
                messageApi.error(error?.response?.data?.title)}
            );
    };
    useEffect(() => {
        if (!isSubmitted) {
            setIsSubmitted(true);
            submitCheckout();
        }
    }, [isSubmitted]);

    return (
        <>
            {contextHolder}

            {/*NOTICE: 訂單未完成*/}
            {getCheckoutInfoData?.checkoutStatus === "VISITED" &&
                !isSubmitted && (
                    <Content>
                        <WrappedCard cardProps={{ className: "rs1-payment-container" }}>
                            <>
                                <div className="rs1-amount-content">
                                    <div className = "rs1-amount">
                                        {getCheckoutInfoData?.orderAmount}
                                    </div>

                                    <div className="rs1-amount-currency">
                                        Amount (PKR)
                                    </div>
                                    <div className="rs1-transaction-fee">
                                        <span style={{float: "left"}}>Transaction Fee</span>
                                        <span style={{float: "right"}}>Free</span>
                                    </div>
                                </div>
                            </>

                            <Form
                                form={form}
                                onFinish={submitCheckout}
                            >
                                <>
                                    <div className="rs1-form-container">
                                        <div className="rs1-input-container">
                                            <Form.Item>
                                                <div className="rs1-submit-button-container">
                                                    <Button type="primary" className="rs1-submit-button"
                                                            htmlType="submit"
                                                            disabled={loading}>
                                                        {loading ? "Paying..." : "Pay"}
                                                    </Button>
                                                </div>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </>
                            </Form>
                        </WrappedCard>
                    </Content>
                )}

            {/* 訂單已提交 */}
            {isSubmitted &&
                <>
                    <WrappedCard
                        cardTitle="Information"
                    >
                        <Descriptions
                            bordered
                        >
                            <Descriptions.Item
                                label="Cumsumer Name"
                            >
                                <Typography.Title
                                    level={5}
                                    style={{margin: 0}}
                                >
                                    {getCheckoutInfoData?.receiverName}
                                </Typography.Title>
                            </Descriptions.Item>

                            <Descriptions.Item
                                label="Amount Payable"
                            >
                                <Typography.Title
                                    level={5}
                                    style={{margin: 0}}
                                >
                                    {getCheckoutInfoData?.orderAmount}
                                </Typography.Title>
                            </Descriptions.Item>
                            <Descriptions.Item
                                label="Consumer Number"
                            >
                                <Typography.Title
                                    copyable={{icon: <Copyable/>}}
                                    level={5}
                                    style={{margin: 0}}
                                >
                                    {getCheckoutInfoData?.consumerId}
                                </Typography.Title>
                            </Descriptions.Item>
                        </Descriptions>
                    </WrappedCard>
                    <WrappedCard
                        cardTitle="Instruction"
                    >
                        <ol>
                            <li>Copy consumer number</li>
                            <li>Log in your easypaisa</li>
                            <li>Choose “See All” - “Payments” - “Fee Collection”</li>
                            <li>Select “Collect Mor”</li>
                            <li>Enter consumer number and pay it</li>
                        </ol>
                        <Button style={{
                            fontSize: 16,
                            color: "white",
                            background: "#1677ff",
                            textAlign: "center"
                        }} onClick={() => {
                            setShowBankCardHintModal(true)
                        }}>Video Tutorial</Button>
                        <Modal
                            open={showBankCardHintModal}
                            closable={false}
                            onOk={() => {
                                setShowBankCardHintModal(false)
                            }}
                            onCancel={() => {
                                setShowBankCardHintModal(false)
                            }}
                        >
                            <video controls width="100%">
                                <source src={teachingVideo} type="video/mp4"/>
                                Your browser does not support the video tag.
                            </video>
                        </Modal>
                    </WrappedCard>
                </>
            }
        </>
    );
}

export default PkBillpayMode;
